import AxiosInstance from "./AxiosInstance";

// Get All Users
export const getAllUsers = async () => {
  try {
    const { data } = await AxiosInstance.get("/users");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
export const deleteUsers = async (user) => {
  try {
    const { data } = await AxiosInstance.delete(`/users/${user._id}`);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
